import {WinForm} from "./winform";
import {AuthService} from "@/service";

const appPathDist: any = WinForm.md.getAppPath_Disk();

export const SettingSavePath = {
  IMDefaultPath: `${appPathDist}\\BigEngineerDatas\\fileRecv\\${AuthService.user() && AuthService.user().UserMdt}`,
  ModelDefaultPath: `${appPathDist}\\BigEngineerDatas\\models`,
  DocDefaultPath: `${appPathDist}\\BigEngineerDatas\\documents`,
  ChatCacheDefaultPath: `${appPathDist}\\BigEngineerDatas\\appCache`,
  WorkStationDefaultPath: `${appPathDist}\\BigEngineerDatas\\workstation`,
  ToolsDefaultPath: `${appPathDist}\\BigEngineerDatas\\tools`,
  BOMConFigDefaultPath: `${appPathDist}\\BigEngineerDatas\\pluginSettings\\BOM`,
}
